export default __webpack_public_path__ + "static/media/WalletConnect.d8f697dc.svg";